import { BmHttp } from "../utils/Global";

export const ListarEstadoCitas = async () => {
  const { data } = await BmHttp().get("listar_estado_cita");
  return data;
};

export const ListarTipoCitas = async () => {
  const { data } = await BmHttp().get("listar_tipo_cita");
  return data;
};

// COBERTURAS-07B1 (R2): idclinica es OPCIONAL. Sin argumento se preserva
// exactamente el comportamiento legacy (backend usa token.idclinica del
// usuario logueado). Con argumento, el backend valida esa clinica contra el
// scope real del usuario (403 si no le pertenece) y devuelve SUS métodos de
// pago -- usado por el modal "Registrar cobro" de ReporteCartera.js, que
// necesita los métodos de la clínica DUEÑA de la factura, no la del usuario.
export const ListarMetoPago = async (idclinica) => {
  const { data } = await BmHttp().get("metodos_pago", { params: idclinica ? { idclinica } : undefined });
  return data;
}

export const ListarTipoTransaccionTC = async () => {
  const { data } = await BmHttp().get("tipo_transacciones_tc");
  return data;
}

export const ListarNivelUsers = async () => {
  const { data } = await BmHttp().get("nivel_user");
  return data;
}

// RP-06A: catalogo de roles RBAC asignables via el CRUD generico de
// usuarios (POST /users) -- el backend ya excluye LEGACY_ADMIN/
// SUPERADMIN_PLATFORM/DOCTOR/inactivos (ver ControllerRole.ts).
export const ListarRolesAsignables = async () => {
  const { data } = await BmHttp().get("roles/assignable");
  return data;
}

export const ListarEstadosResultados = async () => {
  const { data } = await BmHttp().get("resultado_estados");
  return data;
}

// RESULTADOS-05: endpoint con scope por compañia (tipos base + propios de la
// compañia del contexto). Reemplaza al antiguo /resultado_tipo_documentos
// (global) para que los tipos personalizados de la compañia aparezcan en el
// selector del modal de Resultados.
export const ListarTipoDocResultados = async () => {
  const { data } = await BmHttp().get("resultado-tipos-documento");
  return data;
}